<input class="form-control w-auto" [type]="type" [class]="class" [placeholder]="placeholder" [required]="required"
  [ngClass]="{'min-w-7':minW}" [ngModel]="model | myDate:dateFormat" (ngModelChange)="parseDate($event)"
  (change)="onChange()" (keyup.enter)="onEnter()" (blur)="onBlur()" [disabled]="disabled" [name]="name"
  [tabindex]="tabIndex">
<div class="alert-holiday" *ngIf="alert">{{alert|translate}}</div>
